module.exports = __webpack_public_path__ + "img/99.a923f9cf.png";